import React from 'react';
import moment from 'moment'
import {EditCampaign} from "../actionButtons/EditCampaign";

function TableRow(props) {
  const { campaign } = props;
  if ( ! campaign) {
    return null;
  }

  return (
    <tr>
      <td>{ campaign.name }</td>
      <td>{ campaign.notes }</td>
      <td>{ moment(new Date(campaign.start_date)).format("DD-MM-YYYY") }</td>
      <td>{ moment(new Date(campaign.end_date)).format("DD-MM-YYYY") }</td>
      <td className="w-10">
        <EditCampaign id={ campaign.id } index={ props.index } />
      </td>
    </tr>
  )
}

export { TableRow };
